import { createTheme } from '@material-ui/core';
import { fuseDark, skyBlue, newColor } from './colors';
import { red } from '@material-ui/core/colors';

export const myTabsTheme = createTheme({
  palette: {
    type: 'light',
    primary: fuseDark,
    secondary: {
      light: skyBlue[100],
      main: skyBlue[500],
      dark: skyBlue[900],
    },
    error: red,
  },
  overrides: {
    MuiButton: {
      label: {
        textTransform: 'none',
      },
    },
  },
});
